module.exports = __webpack_public_path__ + "static/og-46b0b95bec2a6be27a376acc16a17242.png";